export const IMPORT_TYPE = {
  CSV_IMPORT: 'CSV',
  SOFTWARE_EXPORT: 'SOFTWARE'
};
